export function formatEnumLabel(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return String(value)
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatRunMode(value) {
  const normalized = String(value || '').trim().toUpperCase();

  const RUN_MODE_LABELS = {
    NO_TRADE_FILTERED: 'No Trade',
    NO_TRADE: 'No Trade',
    ACTIVE: 'Active',
    POSTED: 'Posted',
    ENTRY_ACTIVE: 'Entry Active',
    PRIMARY_ENTRY_ACTIVE: 'Primary Entry Active',
    FILTERED: 'Filtered',
    WAITING: 'Waiting',
    INACTIVE: 'Inactive',
  };

  return RUN_MODE_LABELS[normalized] || formatEnumLabel(value);
}